import React from 'react'
import GameData from './Data.json'

function GameList() {

  console.log(GameData.length)
  let game = [];
  let link = [];
  let A = [];
  let B = [];
  let BLink =[];
  let C = [];
  let CLink =[];
  let D = [];
  let E = [];
  let ELink =[];
  let F = [];
  let G = [];
  let H = [];
  let HLink =[];
  let I = [];
  let J = [];
  let K = [];
  let L = [];
  let M = [];
  let MLink =[];
  let N = [];
  let O = [];
  let P = [];
  let Q = [];
  let R = [];
  let RLink =[];
  let S = [];
  let SLink =[];
  let T = [];
  let U = [];
  let V = [];
  let W = [];
  let X = [];
  let Y = [];
  let Z = [];

  for (let i = 0; i < GameData.length; i++) {
    game[i] = GameData[i].title;
    link[i] = GameData[i].link;

    if (game[i][0] === "A") {
      A.push(game[i]);
    }

    if (game[i][0] === "B") {
      B.push(game[i]);
      BLink.push(link[i]);
    }

    if (game[i][0] === "C") {
      C.push(game[i]);
      CLink.push(link[i]);
    }
    if (game[i][0] === "D") {
      D.push(game[i]);
    }
    if (game[i][0] === "E") {
      E.push(game[i]);
      ELink.push(link[i]);

    }
    if (game[i][0] === "F") {
      F.push(game[i]);
    }
    if (game[i][0] === "G") {
      G.push(game[i]);
    }
    if (game[i][0] === "H") {
      H.push(game[i]);
    }
    if (game[i][0] === "I") {
      I.push(game[i]);
    }
    if (game[i][0] === "J") {
      J.push(game[i]);
    }
    if (game[i][0] === "K") {
      K.push(game[i]);
    }
    if (game[i][0] === "L") {
      L.push(game[i]);
    }
    if (game[i][0] === "M") {
      M.push(game[i]);
      MLink.push(link[i]);

    }
    if (game[i][0] === "N") {
      N.push(game[i]);
    }
    if (game[i][0] === "O") {
      O.push(game[i]);
    }
    if (game[i][0] === "P") {
      P.push(game[i]);
    }
    if (game[i][0] === "Q") {
      Q.push(game[i]);
    }
    if (game[i][0] === "R") {
      R.push(game[i]);
      RLink.push(link[i]);

    }
    if (game[i][0] === "S") {
      S.push(game[i]);
      SLink.push(link[i]);

    }
    if (game[i][0] === "T") {
      T.push(game[i]);
    }
    if (game[i][0] === "U") {
      U.push(game[i]);
    }
    if (game[i][0] === "V") {
      V.push(game[i]);
    }
    if (game[i][0] === "W") {
      W.push(game[i]);
    }
    if (game[i][0] === "X") {
      X.push(game[i]);
    }
    if (game[i][0] === "Y") {
      Y.push(game[i]);
    }
    if (game[i][0] === "Z") {
      Z.push(game[i]);
    }

    function ListCGames(){
      for (let i = 0; i < CLink.length; i++) {
        C.map(name => (
          <h5>
              <a href={"https://tabletopencyclopedia.vercel.app/"+CLink[i]}>
            {name}
            </a>
          </h5>
        ))
      }
    }

    ListCGames();
  }
  return (
    <div style={{ marginBottom: 50 }}>
      {/* <h1>A</h1>
      <div>
        {A.map(name => (
          <li>
            {name}
          </li>
        ))}
      </div> */}

      <h1>B</h1>
      <div>
        {B.map(name => (
          <h5>
            <a href={"https://tabletopencyclopedia.vercel.app/"+BLink}>
            {name}
            </a>
         
          </h5>
        ))}
      </div>

      <h1>C</h1>
      <div>
      

    {C.map(name => (
          <h5>
            <a href={"https://tabletopencyclopedia.vercel.app/"+CLink}>
            {name}
            </a>
         
          </h5>
        ))}


        
      </div>

      <h1>E</h1>
      <div>
      {E.map(name => (
          <h5>
            {name}
          </h5>
        ))}
      </div>


      <h1>H</h1>
      <div>
       {H.map(name => (
          <h5>
            <a href={"https://tabletopencyclopedia.vercel.app/"+HLink}>
            {name}
            </a>
         
          </h5>
        ))}
      </div>

      <h1>M</h1>
      <div>
      {M.map(name => (
          <h5>
            {name}
          </h5>
        ))}
      </div>

      <h1>R</h1>
      <div>
      {R.map(name => (
          <h5>
            {name}
          </h5>
        ))}
      </div>

      <h1>S</h1>
      <div>
      {S.map(name => (
          <h5>
            {name}
          </h5>
        ))}
      </div>

    </div>
  )
}

export default GameList
